/**
 * 파일 검증 (P5-①) — kingdoo-editor의 limits.ts + LumirEditor.tsx 인라인 검증 이식.
 * SVG 차단(XSS), MIME+확장자 화이트리스트, 용량 한도.
 */

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 이미지 10MB
export const MAX_VIDEO_FILE_SIZE = 100 * 1024 * 1024; // 비디오 100MB
export const MAX_AUDIO_FILE_SIZE = 50 * 1024 * 1024; // 오디오 50MB
export const MAX_GENERIC_FILE_SIZE = 100 * 1024 * 1024; // 일반 파일 100MB
export const UPLOAD_TIMEOUT = 30000;
export const UPLOAD_TIMEOUT_VIDEO = 120000;

export const ALLOWED_IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
]);
export const BLOCKED_EXTENSIONS = ['.svg', '.svgz'];
export const ALLOWED_IMAGE_EXTENSIONS = [
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.bmp',
];
export const ALLOWED_VIDEO_MIME_TYPES = new Set([
  'video/mp4',
  'video/webm',
  'video/ogg',
  'video/quicktime',
]);
export const ALLOWED_VIDEO_EXTENSIONS = ['.mp4', '.webm', '.ogg', '.mov'];
export const ALLOWED_AUDIO_MIME_TYPES = new Set([
  'audio/mpeg',
  'audio/wav',
  'audio/x-wav',
  'audio/ogg',
  'audio/mp4',
  'audio/aac',
  'audio/webm',
]);
export const ALLOWED_AUDIO_EXTENSIONS = [
  '.mp3',
  '.wav',
  '.ogg',
  '.m4a',
  '.aac',
];

function ext(name) {
  const i = (name || '').lastIndexOf('.');
  return i === -1 ? '' : name.substring(i).toLowerCase();
}

/** 이미지 파일 여부 (SVG 차단, 용량 한도) */
export function isImageFile(file, maxSize = MAX_FILE_SIZE) {
  if (!file || file.size === 0 || file.size > maxSize) return false;
  const e = ext(file.name);
  if (BLOCKED_EXTENSIONS.includes(e)) return false; // .svg/.svgz 차단
  if (file.type === 'image/svg+xml') return false;
  if (ALLOWED_IMAGE_MIME_TYPES.has(file.type)) return true;
  return ALLOWED_IMAGE_EXTENSIONS.includes(e);
}

/** 동영상 파일 여부 (용량 한도) */
export function isVideoFile(file, maxSize = MAX_VIDEO_FILE_SIZE) {
  if (!file || file.size === 0 || file.size > maxSize) return false;
  if (ALLOWED_VIDEO_MIME_TYPES.has(file.type)) return true;
  if (file.type && file.type.startsWith('video/')) return true;
  return ALLOWED_VIDEO_EXTENSIONS.includes(ext(file.name));
}

/** 오디오 파일 여부 (용량 한도) */
export function isAudioFile(file, maxSize = MAX_AUDIO_FILE_SIZE) {
  if (!file || file.size === 0 || file.size > maxSize) return false;
  if (ALLOWED_AUDIO_MIME_TYPES.has(file.type)) return true;
  if (file.type && file.type.startsWith('audio/')) return true;
  return ALLOWED_AUDIO_EXTENSIONS.includes(ext(file.name));
}

/** 일반 파일 허용 여부 (SVG만 차단, 용량 한도) */
export function isGenericFile(file, maxSize = MAX_GENERIC_FILE_SIZE) {
  if (!file || file.size === 0 || file.size > maxSize) return false;
  if (BLOCKED_EXTENSIONS.includes(ext(file.name))) return false;
  return true;
}

/** HTML 파일 여부 */
export function isHtmlFile(file) {
  if (!file || file.size === 0) return false;
  if (file.type === 'text/html') return true;
  const e = ext(file.name);
  return e === '.html' || e === '.htm';
}

/** HTML 텍스트 이스케이프(URL/사용자 입력 → 안전 삽입) */
export function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}
